import { useTranslation } from 'react-i18next'

import { helpers } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ReturnInstructionPreview = ({ steps }) => {
  const { t } = useTranslation()

  if (!steps?.length) return null

  return (
    <Styles.PreviewContainer data-testid="instruction-preview">
      <Styles.PreviewTitle type="bodyLBold">{t('Instrucciones de devolución')}</Styles.PreviewTitle>
      {steps.map((step, index) => (
        <Styles.StepRow key={index}>
          <Styles.StepNumber>{index + 1}</Styles.StepNumber>
          <Styles.StepContent dangerouslySetInnerHTML={{ __html: helpers.replaceNonBreakingSpaces(step) }} />
        </Styles.StepRow>
      ))}
    </Styles.PreviewContainer>
  )
}

export default ReturnInstructionPreview
